<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Requisición</th>
                <th :class="StyleTh">Fecha de Entrega</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh+' text-center'">Elaboración</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                    <td><p :class="StyleTd">{{lista.requisiciones.Folio}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaEntrega,false)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus}}</p></td>
                    <td><p :class="StyleTd">$ {{lista.Total}}</p></td>
                    <td class="text-center">
                        <button type="button" v-b-tooltip.hover.rightbottom :title="TituloElaboracion(lista)" class="btn btn-link text-warning px-3 mb-0 mr-1">
                            <i class="fas fa-user text-warning"></i>
                        </button>
                    </td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="lista.Estatus=='Finalizado' ? false : true" :pShowBtnDelete="lista.Estatus=='Pendiente' ? true : false" :pIsModal="false" :pId="lista.IdOrdenCompra" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                            <template slot="btnaccion">
                                <CMoreButtonsL>
                                    <template slot="bodyBtnsL">
                                        <template v-if="segurity.RequestAuthorization">
                                            <li v-show="lista.Estatus=='Pendiente'" @click="SolicitarAutorizacion(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-user-check"></i> Solicitar Autorización
                                                </a>
                                            </li>
                                        </template>
                                        <template v-if="segurity.Authorize">
                                            <li v-show="lista.Estatus=='Solicitando'" @click="Autorizar(lista)">
                                                <a class="dropdown-item">
                                                    <i class="fas fa-user-check"></i> Autorizar Orden de Compra
                                                </a>
                                            </li>
                                        </template>
                                        <li>
                                            <a class="dropdown-item" @click="VerPdf(lista)">
                                                <i class="fas fa-file-pdf"></i> Ver PDF
                                            </a>
                                        </li>
                                    </template>
                                </CMoreButtonsL>
                                <!-- <button v-show="lista.Estatus=='Pendiente'" @click="SolicitarAutorizacion(lista)" class="btn btn-warning btn-icon" style="margin-right:5px" v-b-tooltip.hover.rightbottom title="Solicitar Autorizacion" type="button">
                                    <i class="fas fa-user-check"></i>
                                </button> -->
                                <!-- <button v-show="lista.Estatus=='Solicitando'" @click="Autorizar(lista)" class="btn btn-warning btn-icon" style="margin-right:5px" v-b-tooltip.hover.rightbottom title="Autorizar Orden de Compra" type="button">
                                    <i class="fas fa-file-check"></i>
                                </button> -->
                                <!-- <button class="btn btn-warning btn-icon" v-b-tooltip.hover.rightbottom title="Ver PDF" type="button">
                                    <i class="fas fa-file-pdf"></i>
                                </button> -->
                            </template>
                        </CBtnAccion>     
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
            </template>
        </CList>
    </div>
</template>

<script>
// import Form from '../requisicion/AutorizarForm.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionOrdenCompra';
export default {
    name: 'ListaOrdenCompra',
    props: ['sFiltros','pOrigen'],
    components: {
        // Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Ordenes de Compra',
                IsModal: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Almacen',
                GoRoute:'OrdenCompraForm'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader=true;
            await this.$http.get("ordenCompra",{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Pag:this.Filtro.Pagina,
                    Entrada:this.Filtro.Entrada
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('ordenCompra/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus'});
        },
        SolicitarAutorizacion(item){
            this.$swal(Configs.configSolicitarAutorizacionCompra).then((result) =>
            {
                if(result.value)
                {
                    this.$http.put('ordenCompraSolicitando/'+item.IdOrdenCompra,item
                    ).then((res) => {
                        this.$swal(Configs.configSolicitarAutorizacionConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Autorizar(item){
            this.$swal(Configs.configAutorizarCompra).then((result) =>
            {
                if(result.value)
                {
                    this.$http.put('ordenCompraAutorizado/'+item.IdOrdenCompra,item
                    ).then((res) => {
                        this.$swal(Configs.configAutorizarCompraConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        TituloElaboracion(item){
            let cadena="";
            let UsuarioAutorizo=item.usuario_autorizo==null ? '' : item.usuario_autorizo.NombreCompleto;
            let FechaAutorizacion=item.FechaAutorizacion==null ? '' : this.$getCleanDate(item.FechaAutorizacion,true);
            cadena="Elaboró: "+item.usuario_elaboro.NombreCompleto+
            "\n Fecha Elaboración: "+this.$getCleanDate(item.FechaExp,true);
            if (item.usuario_autorizo!=null) {
                cadena+="\n Autorizó: "+UsuarioAutorizo+
                "\n Fecha Autorización: "+FechaAutorizacion;
            }
            return cadena;
        },
        VerPdf(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdOrdenCompra: item.IdOrdenCompra
			}

			this.$http.post('rptpdfOrdenCompra',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("OrdenCompra",'OrdenCompra_'+item.IdOrdenCompra,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        }
    },
    created() {
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>